import { NgModule } from '@angular/core';
import { CommonModule,DatePipe } from '@angular/common';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { TextMaskModule } from 'angular2-text-mask';
import { CustomFormsModule } from 'ng2-validation';
import { FormRoutingModule } from './form-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { BasicInputsComponent } from './basic-inputs/basic-inputs.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { EditorComponent } from './editor/editor.component';
import { FormLayoutsComponent } from './form-layouts/form-layouts.component';
import { InputGroupComponent } from './input-group/input-group.component';
import { MasksComponent } from './masks/masks.component';
import { TimepickerComponent } from './timepicker/timepicker.component';
import { ValidationComponent } from './validation/validation.component';

import { ChartsModule } from 'ng2-charts';
import { ToiletComponent } from './master/toilet/toilet.component';
import { DevicesComponent } from './master/devices/devices.component';
import { AgmCoreModule } from '@agm/core';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { InstallDeviceReportComponent } from './report/install-device-report/install-device-report.component';
import { ActiveDeviceReportComponent } from './report/active-device-report/active-device-report.component';
import { InactiveDeviceReportComponent } from './report/inactive-device-report/inactive-device-report.component';
//import { AirQualityReportComponent } from '../../app/form/report/air-quality-report/air-quality-report';
import { AirQualityReportComponent } from './report/air-quality-report/air-quality-report';
import { UserFeedbackReportComponent } from './report/user-feedback-report/user-feedback-report.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { HelpComponent } from './help/help.component';
import { ToiletReportComponent } from './report/toilet-report/toilet-report.component';

import { DataTablesModule } from 'angular-datatables';
import { AirQualityDetailReportComponent } from './report/air-quality-detail-report/air-quality-detail-report.component';
import { UserFeedbackDetailReportComponent } from './report/user-feedback-detail-report/user-feedback-detail-report.component';
import { WaterLavelReportComponent } from './report/water-lavel-report/water-lavel-report.component';
import { DeviceLocationComponent } from './device-location/device-location.component';
import { DeviceLogComponent } from './report/device-log/device-log.component';
import { UsersComponent } from './master/users/users.component';
import { ToiletDashboardComponent } from './toilet-dashboard/toilet-dashboard.component';
import { ToiletStatusReportComponent } from './report/toilet-status-report/toilet-status-report.component';
import { OfficerMasterComponent } from './master/officer-master/officer-master.component';

@NgModule({
  declarations: [
    BasicInputsComponent,
    InputGroupComponent, 
    FormLayoutsComponent,
    MasksComponent, 
    EditorComponent, 
    ValidationComponent, 
    TimepickerComponent,
    DatepickerComponent,
    DashboardComponent,
    ToiletComponent,
    DevicesComponent,
    InstallDeviceReportComponent,
    ActiveDeviceReportComponent,
    InactiveDeviceReportComponent,
    AirQualityReportComponent,
    UserFeedbackReportComponent,
    AboutUsComponent,
    HelpComponent,
    ToiletReportComponent,
    AirQualityDetailReportComponent,
    UserFeedbackDetailReportComponent,
    WaterLavelReportComponent,
    DeviceLocationComponent,
    DeviceLogComponent,
    UsersComponent,
    ToiletDashboardComponent,
    ToiletStatusReportComponent,
    OfficerMasterComponent
  ],
  imports: [
    CommonModule,
    FormRoutingModule,
    NgbModule,
    AgmCoreModule,
    FormsModule,
    // AgmCoreModule.forRoot({ apiKey: 'AIzaSyDKXKdHQdtqgPVl2HI2RnUa_1bjCxRCQo4' }),  
    ReactiveFormsModule,
    NgbProgressbarModule,
    CustomFormsModule,
    TextMaskModule,
    ChartsModule,
    NgSelectModule,
    DataTablesModule
  ],
  providers: [
    DatePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], 
  exports: [
    DashboardComponent,  
  ]
})
export class FormModule { }
